import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html'
})
export class AddressComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();
  showPostalAddress = false;

  @Input() address: any;

  uniqueIden: any;

  constructor(private fb: FormBuilder) { 
    
  }

  form = this.fb.group({
    physicalAddress1: ['', [Validators.required]],
    physicalAddress2: [''],
    physicalCity: ['', [Validators.required]],
    physicalState: ['', [Validators.required]],
    physicalZip: ['', [Validators.required]],
    postalAddress1: ['', [Validators.required]],
    postalAddress2: [''],
    postalCity: ['', [Validators.required]],
    postalState: ['', [Validators.required]],
    postalZip: ['', [Validators.required]],
    celPhone: ['', [Validators.required]],
    homePhone: ['']
  });

  ngOnInit(){
    if(this.address) {
      this.uniqueIden = this.address.celPhone.slice(this.address.celPhone.indexOf('-') + 1);
      
    }
    else this.uniqueIden = (new Date()).toString();
    this.formReady.emit(this.form);
    
  }

  ngAfterViewInit(){
    if(this.address) {
      this.setAddress();
    }
  }

  setAddress(){ 
    this.form.patchValue(this.address);
    if(!("physicalAddress1" in this.address)){
      return;
    }
    if(this.address.physicalAddress1 == this.address.postalAddress1 && this.address.physicalZip == this.address.postalZip ){
      console.log('same address');
      console.log(this.address);
      let radioBtn:any = document.querySelector('#sameAddressSi'+this.uniqueIden);
      if(radioBtn) radioBtn.checked = true;
      this.showPostalAddress = false;
    } else{
      let radioBtn:any = document.querySelector('#sameAddressNo'+this.uniqueIden);
      if(radioBtn) radioBtn.checked = true
      this.showPostalAddress = true;
    }
    
  }


  sameAddress(value:any){
    let sameAddress = value.target.value;
    if(sameAddress == "si"){
      this.showPostalAddress = false;
      this.form.patchValue({
        postalAddress1: this.form.get('physicalAddress1')!.value,
        postalAddress2: this.form.get('physicalAddress2')!.value,
        postalCity: this.form.get('physicalCity')!.value,
        postalState: this.form.get('physicalState')!.value,
        postalZip: this.form.get('physicalZip')!.value
      })
    }
    else if(sameAddress == "no"){
      this.showPostalAddress = true;
      this.form.patchValue({
        postalAddress1: '',
        postalAddress2: '',
        postalCity: '',
        postalState: '',
        postalZip: ''
      })
    }
  }

  updatePostalState(){
    let postalState = this.form.get('postalState')!.value;
    this.form.patchValue({
      postalState: postalState?.toUpperCase()
    })
  }

  updatePhysicalState(){
    let physicalState = this.form.get('physicalState')!.value;
    this.form.patchValue({
      physicalState: physicalState?.toUpperCase()
    })
  }

}
